import React from "react";
import type { PreviewNewsCard } from "../types";
import { Card } from "../../../components/ui/primitives";

export function PreviewCardView({
  card,
  loading,
}: {
  card: PreviewNewsCard | null;
  loading?: boolean;
}) {
  return (
    <Card className="p-5">
      <div className="text-xs leading-relaxed text-white/60">
        {loading ? "Loading…" : card?.paragraph}
      </div>

      <div className="mt-4 space-y-2">
        <div className="rounded-lg border border-rose-400/15 bg-rose-400/10 p-3">
          <div className="text-[11px] font-semibold text-rose-200">Bearish:</div>
          <div className="mt-1 text-[11px] leading-relaxed text-white/60">
            {card?.bearish}
          </div>
        </div>
        <div className="rounded-lg border border-emerald-400/15 bg-emerald-400/10 p-3">
          <div className="text-[11px] font-semibold text-emerald-200">Bullish:</div>
          <div className="mt-1 text-[11px] leading-relaxed text-white/60">
            {card?.bullish}
          </div>
        </div>
      </div>

      <div className="mt-3 text-[11px] text-white/45">Sources: {card?.sources ?? "—"}</div>
    </Card>
  );
}
